import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

export const TechnicalDifficultiesContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-6, 24px);
`

export const TechnicalDifficultiesMessagesContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: var(--spacing-2, 8px);
`

export const TechnicalDifficultiesTitle = styled.h1`
  ${font('2xl', 'bold')}
`

export const TechnicalDifficultiesDescription = styled.p`
  ${font('base', 'regular')}
`
